import { render, staticRenderFns } from "./EditionsTable.vue?vue&type=template&id=614eb0a0&"
import script from "./EditionsTable.vue?vue&type=script&lang=js&"
export * from "./EditionsTable.vue?vue&type=script&lang=js&"
import style0 from "./EditionsTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports